import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import Moment from 'moment';
import {withRouter} from 'react-router-dom';
import {cloneDeep, truncate} from 'lodash';
import {createFragmentContainer, graphql} from 'react-relay';
//import {withSocketHandling} from '../../../socket/withSocketHandling';
import CreateRetainerPeriodMutation from '../../../mutations/create_retainer_period_mutation';
import Util from '../../../forecast-app/shared/util/util';
import {BUTTON_COLOR, BUTTON_STYLE, ELEMENT_TYPE, EMPTY_STATE, PERIOD_BUDGET_TYPE, PERIODICITY} from '../../../constants';
import {createToast} from '../../../forecast-app/shared/components/toasts/another-toast/toaster';
import RetainerPeriod from '../../../components/new-ui/retainer_period/retainer_period';
import RetainerPeriodWarningTab from '../../../components/new-ui/retainer_period/retainer_period_warning_tab';
import {Scrollbars} from 'react-custom-scrollbars';
import HeaderBar, {buildThirdLevelNavHeader} from '../../../forecast-app/shared/components/headers/header-bar/header_bar';
import Button from '../../../forecast-app/shared/components/buttons/button/button';
import {Bar} from 'react-chartjs-2';
import {MODAL_TYPE, showModal} from '../../../forecast-app/shared/components/modals/generic_modal_conductor';
import PeriodRolloverTexture from '../../../images/v2/components/periodbar-rollover.png';
import PeriodSubtractionTexture from '../../../images/v2/components/periodbar-subtract.png';
import PeriodStandardTexture from '../../../images/v2/components/periodbar-standard.png';
import {getGradients} from '../../../components/new-ui/project/project-budget-v2/components/budget_charts/budget_charts_util.js';
import * as tracking from '../../../tracking';
import UpdateProjectMutation from '../../../mutations/update_project_mutation.modern';
import EmptyState from '../../../forecast-app/shared/components/empty-states/empty_state';
import { hasFeatureFlag, usingTimeApproval } from "../../../forecast-app/shared/util/FeatureUtil";
import {timeRegIsInConflict} from '../../../components/new-ui/retainer_period/RetainerPeriodUtil';
import {dispatch, EVENT_ID} from '../../event_manager';
import {TopHeaderBar, TopHeaderBarWrapper} from '../../../forecast-app/shared/components/headers/top-header-bar/TopHeaderBar';
import {hasSomePermission} from '../../../forecast-app/shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../../Permissions';

class projectRetainerPeriods extends Component {
	constructor(props) {
		super(props);
		let lastViewedPage;
		if (this.props.viewer.projectGroup) {
			lastViewedPage = localStorage.getItem('project-group-section-last-viewed') || 'workflow';
			if (lastViewedPage === 'periods') lastViewedPage = 'workflow';
			this.props.history.push('/connected/X-' + this.props.viewer.projectGroup.companyProjectGroupId + '/' + lastViewedPage);
		} else if (this.props.viewer.project && props.viewer.project.budgetType !== 'RETAINER') {
			lastViewedPage = localStorage.getItem('project-section-last-viewed') || 'workflow';
			if (lastViewedPage === 'periods') lastViewedPage = 'workflow';
			this.props.history.push('/project/P-' + this.props.viewer.project.companyProjectId + '/' + lastViewedPage);
		}
		this.state = {
			topOffset: null,
			searchFilterValue: '',
			selectedPeriod: localStorage.getItem('RETAINER_SELECTED_TAB') ? localStorage.getItem('RETAINER_SELECTED_TAB') : 'ALL',
		};
		this.setPeriodSelection = this.setSelectedPeriod.bind(this);
		this.onWindowResize = this.onWindowResize.bind(this);
	}

	UNSAFE_componentWillMount() {
		const path = this.props.history.location.pathname;
		if (!Util.AuthorizeViewerAccess('project-periods')) {
			if (Util.pathIncludesTask(path)) {
				const cardPath = path.substring(Util.indexOfTask(path), path.length);
				this.props.history.push('/project/P-' + this.props.viewer.project.companyProjectId + '/workflow/' + cardPath);
			} else {
				// if user doesnt have access rights to view this page redirect to no access page
				this.props.history.push('/not-authorized');
				Util.localStorageSetItem('project-section-last-viewed', 'workflow');
			}
		}
	}

	componentDidMount() {
		window.addEventListener('resize', this.onWindowResize);

		document.title = 'Periods - ' + this.props.viewer.project.name + ' - Forecast';
		if (this.retainerContainer) {
			this.setState({topOffset: this.retainerContainer.getBoundingClientRect().top});
		}
		if (localStorage.getItem('RETAINER_SELECTED_TAB') == null && this.state.selectedPeriod === 'CURRENT') {
			if (this.props.viewer.project.retainerPeriods.edges.filter(this.filterByActiveSelection.bind(this)).length === 0) {
				this.setState({selectedPeriod: 'ALL'});
			}
		}

		tracking.trackPage('Retainer-periods');

		dispatch(EVENT_ID.PAGE_LOADED, 'retainer_periods');
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onWindowResize);
	}

	onWindowResize() {
		clearTimeout(this.sizeResizeTimer);
		this.sizeResizeTimer = setTimeout(() => this.forceUpdate(), 5);
	}

	addPeriod() {
		const {formatMessage} = this.props.intl;
		const project = this.props.viewer.project;
		const sortedPeriods = cloneDeep(project.retainerPeriods.edges).sort(this.sortByStartDate);
		const firstRetainerPeriod = sortedPeriods[0];
		const latestRetainerPeriod = sortedPeriods[sortedPeriods.length - 1];
		const existingValue = project.retainerPeriods.edges.reduce((acc, period) => acc + (project.defaultPeriodBudgetType === PERIOD_BUDGET_TYPE.FIXED_HOURS ? period.node.periodHoursAmount : period.node.periodPriceAmount), 0);

		const firstRetainerPeriodStartDate = firstRetainerPeriod
			? Moment()
					.set('year', firstRetainerPeriod.node.startYear)
					.set('month', firstRetainerPeriod.node.startMonth - 1)
					.set('date', firstRetainerPeriod.node.startDay)
			: Moment().set({
					year: project.projectStartYear,
					month: project.projectStartMonth - 1,
					date: project.projectStartDay,
			  });
		const latestRetainerPeriodEndDate = latestRetainerPeriod
			? Moment()
					.set('year', latestRetainerPeriod.node.endYear)
					.set('month', latestRetainerPeriod.node.endMonth - 1)
					.set('date', latestRetainerPeriod.node.endDay)
			: firstRetainerPeriodStartDate.clone().subtract(1, 'days');

		const handleBulkCreatePeriods = preCreateAmount => {
			if (preCreateAmount > 0) {
				const onSuccess = result => {
					// Not the most beautiful approach but range add does not work for bulk creation.
					this.props.retry();
					createToast({duration: 5000, message: formatMessage({id: 'retainer.period-created'})});

					// Update end-date of project
					const newProjectEndDate = latestRetainerPeriodEndDate
						.clone()
						.add(project.defaultPeriodLength * preCreateAmount, project.defaultPeriodPeriodicity === PERIODICITY.DAILY ? 'days' : project.defaultPeriodPeriodicity === PERIODICITY.WEEKLY ? 'weeks' : 'months');
					const projectMutationObject = {
						project: project,
						projectEndDay: newProjectEndDate.date(),
						projectEndMonth: newProjectEndDate.month() + 1,
						projectEndYear: newProjectEndDate.year(),
					};
					Util.CommitMutation(UpdateProjectMutation, projectMutationObject);
				};
				let startDate = Moment();

				// If first period
				if (project.retainerPeriods.edges.length === 0) {
					const projectStart = Moment().set({
						year: project.projectStartYear,
						month: project.projectStartMonth - 1,
						date: project.projectStartDay,
					});
					const today = Moment().startOf('day');
					startDate = projectStart.isBefore(today) ? today : projectStart;
				} else {
					const afterLastRetainerPeriod = Moment()
						.set('year', latestRetainerPeriod.node.endYear)
						.set('month', latestRetainerPeriod.node.endMonth - 1)
						.set('date', latestRetainerPeriod.node.endDay + 1);
					startDate = afterLastRetainerPeriod;
				}

				//const formattedDeadline = Util.GetYearMonthDateFromMomentDate(deadline);
				const mutationObject = {
					name: formatMessage({id: 'retainer.new_period'}),
					projectId: project.id,
					startDay: startDate.date(),
					startMonth: startDate.month() + 1,
					startYear: startDate.year(),
					preCreateAmount: +preCreateAmount,
				};
				Util.CommitMutation(CreateRetainerPeriodMutation, mutationObject, onSuccess);
			}
		};

		showModal({
			type: MODAL_TYPE.ADD_PERIODS,
			handleConfirm: handleBulkCreatePeriods.bind(this),
			defaultPeriodLength: project.defaultPeriodLength,
			defaultPeriodPeriodicity: project.defaultPeriodPeriodicity,
			defaultPeriodBudgetType: project.defaultPeriodBudgetType,
			defaultPeriodHoursAmount: project.defaultPeriodHoursAmount,
			defaultPeriodPriceAmount: project.defaultPeriodPriceAmount,
			existingValue: existingValue,
			currency: project.rateCard ? project.rateCard.currency : this.props.viewer.company.currency,
			firstPeriodStartDate: firstRetainerPeriodStartDate,
			latestPeriodEndDate: latestRetainerPeriodEndDate,
		});
	}

	goToOverview() {
		this.props.history.push('/project/P-' + this.props.viewer.project.companyProjectId + '/overview?set_dates=true');
	}

	sortByEndDate(a, b) {
		const aDate = Util.CreateNonUtcMomentDate(a.node.endYear, a.node.endMonth, a.node.endDay);
		const bDate = Util.CreateNonUtcMomentDate(b.node.endYear, b.node.endMonth, b.node.endDay);
		if (aDate.isAfter(bDate)) return -1;
		if (bDate.isAfter(aDate)) return 1;
		return 0;
	}

	sortByStartDate(a, b) {
		const aDate = Util.CreateNonUtcMomentDate(a.node.startYear, a.node.startMonth, a.node.startDay);
		const bDate = Util.CreateNonUtcMomentDate(b.node.startYear, b.node.startMonth, b.node.startDay);
		if (!aDate || !bDate) return 0;
		if (aDate.isBefore(bDate)) return -1;
		if (bDate.isBefore(aDate)) return 1;
		return 0;
	}

	sortByTimeRegDate(a, b) {
		const aDate = Util.CreateNonUtcMomentDate(a.node.year, a.node.month, a.node.day);
		const bDate = Util.CreateNonUtcMomentDate(b.node.year, b.node.month, b.node.day);
		if (aDate.isAfter(bDate)) return 1;
		if (bDate.isAfter(aDate)) return -1;
		return 0;
	}

	getTimeRegsForPeriod(timeRegs, period, removeConflicts) {
		const startDate = Util.CreateMomentDate(period.startYear, period.startMonth, period.startDay);
		const endDate = Util.CreateMomentDate(period.endYear, period.endMonth, period.endDay);
		const timeRegWithinDate = timeReg => {
			const tDate = Util.CreateMomentDate(timeReg.node.year, timeReg.node.month, timeReg.node.day);
			return tDate && tDate.isSameOrAfter(startDate) && tDate.isSameOrBefore(endDate);
		};
		if (removeConflicts) {
			return timeRegs.filter(timeReg => timeRegWithinDate(timeReg) && !timeRegIsInConflict(timeReg.node, period)).sort(this.sortByTimeRegDate);
		}
		return timeRegs.filter(timeReg => timeRegWithinDate(timeReg)).sort(this.sortByTimeRegDate);
	}

	getAvailableForPeriod(period) {
		const today = Moment();
		const periodEndDate = Util.CreateMomentDate(period.endYear, period.endMonth, period.endDay);
		if (today.isAfter(periodEndDate, 'day')) {
			return 0;
		} else {
			return period.available / 60;
		}
	}

	getWorkedHoursForPeriod(timeRegs, period) {
		const filteredTimeRegs = this.getTimeRegsForPeriod(timeRegs, period, true);
		return filteredTimeRegs.reduce((acc, tReg) => acc + tReg.node.minutesRegistered / 60, 0);
	}

	getWorkedPriceForPeriod(timeRegs, period) {
		const filteredTimeRegs = this.getTimeRegsForPeriod(timeRegs, period, true);
		return filteredTimeRegs.reduce((acc, tReg) => acc + tReg.node.price, 0);
	}

	getForecastForPeriod(periodPhases) {
		return periodPhases ? periodPhases.reduce((acc, phase) => acc + phase.forecast / 60, 0) : 0;
	}

	getEstimatedForecastPriceForPeriod(periodPhases) {
		return periodPhases ? periodPhases.reduce((acc, phase) => acc + phase.estimateForecastPrice, 0) : 0;
	}

	getRemainingForPeriod(periodPhases) {
		return periodPhases ? periodPhases.reduce((acc, phase) => acc + phase.remaining / 60, 0) : 0;
	}

	getRemainingPriceForPeriod(periodPhases) {
		return periodPhases ? periodPhases.reduce((acc, phase) => acc + phase.remainingPrice, 0) : 0;
	}

	handleFilterChange(filterType, value) {
		this.setState({[filterType + 'FilterValue']: value});
		if (typeof value === 'string') {
			Util.localStorageSetItem('project-sprints-filter-value-' + (!this.isConnectedParent ? this.props.viewer.project.id : this.props.viewer.projectGroup.id) + '-' + filterType, JSON.stringify(value));
		} else {
			Util.localStorageSetItem(
				'project-sprints-filter-value-' + (!this.isConnectedParent ? this.props.viewer.project.id : this.props.viewer.projectGroup.id) + '-' + filterType,
				JSON.stringify(
					value.map(v => ({
						...v,
						label: null,
					}))
				)
			);
		}
	}

	setSelectedPeriod(period) {
		Util.localStorageSetItem('RETAINER_SELECTED_TAB', period);
		this.setState({selectedPeriod: period});

		tracking.trackElementClicked(period + ' periods');
	}

	filterByActiveSelection(elem) {
		//Creating a new period with a selectedPeriod result as an node full of null values
		if (elem.node.name === null) return false;

		const today = Moment();
		const elemStartDate = Util.CreateMomentDate(elem.node.startYear, elem.node.startMonth, elem.node.startDay);
		const elemEndDate = Util.CreateMomentDate(elem.node.endYear, elem.node.endMonth, elem.node.endDay);
		switch (this.state.selectedPeriod) {
			case 'FUTURE': {
				return elemStartDate.isAfter(today, 'day');
			}
			case 'PAST': {
				return elemEndDate.isBefore(today, 'day');
			}
			case 'CURRENT': {
				return elemStartDate.isSameOrBefore(today, 'day') && elemEndDate.isSameOrAfter(today, 'day');
			}
			default:
				return true;
		}
	}

	// TODO: We don't check for loading of images here. This should be fixed, and is what is causing the patterns to not always be rendered
	setPatterns(ctx) {
		var negativeImg = new Image();
		negativeImg.src = PeriodSubtractionTexture;
		negativeImg.onload = () => {
			const negativePattern = ctx.createPattern(negativeImg, 'repeat');
			if (negativePattern !== this.state.negativePattern) {
				this.setState({
					negativePattern: negativePattern,
				});
			}
		};
		var positiveImg = new Image();
		positiveImg.src = PeriodRolloverTexture;
		positiveImg.onload = () => {
			const positivePattern = ctx.createPattern(positiveImg, 'repeat');
			if (positivePattern !== this.state.positivePattern) {
				this.setState({
					positivePattern: positivePattern,
				});
			}
		};
		var standardImg = new Image();
		standardImg.src = PeriodStandardTexture;
		standardImg.onload = () => {
			const standardPattern = ctx.createPattern(standardImg, 'repeat');
			if (standardPattern !== this.state.standardPattern) {
				this.setState({
					standardPattern: standardPattern,
				});
			}
		};
	}

	exportCSV() {
		const {formatNumber, formatDate} = this.props.intl;
		const project = this.props.viewer.project;
		const timeRegs = project.timeRegistrations.edges.filter(timeReg => (timeReg.node.task ? timeReg.node.task.billable : true));
		const isTimeMaterial = project.defaultPeriodBudgetType === PERIOD_BUDGET_TYPE.TIME_AND_MATERIALS;

		const sortedPeriods = cloneDeep(project.retainerPeriods.edges)
			.sort(this.sortByStartDate)
			.map(period => period.node);
		const inHours = project.defaultPeriodBudgetType === PERIOD_BUDGET_TYPE.FIXED_HOURS || project.defaultPeriodBudgetType === PERIOD_BUDGET_TYPE.TIME_AND_MATERIALS;
		const format = inHours ? 'rounded_two_decimal' : 'always_two_decimal';
		let data = [];

		sortedPeriods.forEach(p => {
			const timeRegsForPeriod = this.getTimeRegsForPeriod(timeRegs, p).map(timeReg => timeReg.node);
			const nonConflictedTimeEntries = timeRegsForPeriod.filter(timeReg => isTimeMaterial || !timeRegIsInConflict(timeReg, p));

			const totalTime = nonConflictedTimeEntries.reduce((acc, timeReg) => acc + timeReg.minutesRegistered / 60, 0);
			const totalPrice = nonConflictedTimeEntries.reduce((acc, timeReg) => acc + timeReg.price, 0);

			const dateString =
				(p.startYear
					? formatDate(Util.CreateNonUtcMomentDate(p.startYear, p.startMonth, p.startDay), {
							year: 'numeric',
							month: 'short',
							day: 'numeric',
					  })
					: '') +
				' - ' +
				(p.endYear
					? formatDate(Util.CreateNonUtcMomentDate(p.endYear, p.endMonth, p.endDay), {
							year: 'numeric',
							month: 'short',
							day: 'numeric',
					  })
					: '');
			const periodTarget = inHours ? p.periodHoursAmount * 60 : p.periodPriceAmount;
			const periodDifference = inHours ? p.periodDifferenceHoursAmount * 60 : p.periodDifferencePriceAmount;
			const periodTargetTotal = periodTarget + periodDifference;
			const totalValue = inHours ? totalTime * 60 : totalPrice;
			const remainingValue = periodTargetTotal - totalValue;
			const ignoredRollover = inHours ? p.ignoredRollover * 60 : p.ignoredRolloverPrice;
			const progress = periodTargetTotal <= 0 ? 100 : inHours ? Math.round((totalTime / periodTargetTotal) * 100 * 10) / 10 : Math.round((totalPrice / periodTargetTotal) * 100 * 10) / 10;
			const d = {
				'period-name': p.name,
				'period-dates': dateString,
				'period-progress': formatNumber(progress) + '%',
				'period-target': formatNumber(periodTarget, {format: format}),
				'period-rollover': formatNumber(periodDifference, {format: format}),
				'period-target-total': formatNumber(periodTargetTotal, {format: format}),
				'period-used-value': formatNumber(totalValue, {format: format}),
				'period-remaining-value': formatNumber(remainingValue, {format: format}),
				'period-locked': p.periodLocked ? 'locked' : '',
				'period-rollover-absorbed': p.periodLocked ? formatNumber(ignoredRollover, {format: format}) : '',
			};

			data.push(d);
		});

		const colNameSuffix = inHours ? '(min)' : `(${Util.GetCurrencySymbol(project.rateCard ? project.rateCard.currency : this.props.viewer.company.currency)})`;

		const columnNames = [
			'period-name',
			'period-dates',
			'period-progress',
			'period-target ' + colNameSuffix,
			'period-rollover ' + colNameSuffix,
			'period-target-total ' + colNameSuffix,
			'period-used-value ' + colNameSuffix,
			'period-remaining-value ' + colNameSuffix,
			'period-locked',
			'period-rollover-absorbed ' + colNameSuffix,
		];
		let exportData = columnNames + '\r\n';
		exportData += Util.JSONToCSV(data);
		const fileName = project.name.replace(' ', '_').toLowerCase() + '_retainer_period_data.csv';
		Util.exportToCSV(exportData, fileName);
	}

	render() {
		if (!Util.AuthorizeViewerAccess('project-periods')) {
			return <div></div>;
		}
		const project = this.props.viewer.project;
		const phases = project.phases.edges.map(phase => phase.node);
		const allRetainerPeriods = cloneDeep(project.retainerPeriods.edges); // For totals, untouched by filters
		const inHours = project.defaultPeriodBudgetType === PERIOD_BUDGET_TYPE.FIXED_HOURS || project.defaultPeriodBudgetType === PERIOD_BUDGET_TYPE.TIME_AND_MATERIALS;
		const isTimeMaterial = project.defaultPeriodBudgetType === PERIOD_BUDGET_TYPE.TIME_AND_MATERIALS;
		const isFixedPrice = project.defaultPeriodBudgetType === PERIOD_BUDGET_TYPE.FIXED_PRICE && hasFeatureFlag('retainer_fixed_price_v2', this.props.viewer.availableFeatureFlags);
		const {formatMessage, formatNumber} = this.props.intl;
		const projectLocked = this.props.viewer.project.status === 'DONE' || this.props.viewer.project.status === 'HALTED';
		const currency = project.rateCard ? this.props.viewer.project.rateCard.currency : this.props.viewer.company.currency;
		const useTimeApproval = usingTimeApproval(this.props.viewer.company);
		const {estimationUnit} = project;
		const isEstimatedInPoints = estimationUnit !== 'HOURS';

		const withSuffix = (val, asText) => {
			return asText ? (
				inHours ? (
					Util.convertMinutesToFullHour(val * 60, this.props.intl)
				) : (
					Util.getFormattedCurrencyValue(Util.GetCurrencySymbol(currency), formatNumber(val, {format: 'always_two_decimal'}))
				)
			) : (
				<span className={'suffixed-text' + (!inHours ? ' price' : '')}>
					{inHours ? Util.convertMinutesToFullHour(val * 60, this.props.intl) : Util.getFormattedCurrencyValue(Util.GetCurrencySymbol(currency), formatNumber(val, {format: 'always_two_decimal'}))}
				</span>
			);
		};
		const timeRegs = project.timeRegistrations.edges.filter(timeReg => (timeReg.node.task ? timeReg.node.task.billable : true));
		const rightContent = [];
		const leftContent = [];
		const hasFinancialAccess = hasSomePermission([PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION, PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION_REVENUE]);
		const projectStart = Util.CreateMomentDate(project.projectStartYear, project.projectStartMonth, project.projectStartDay);
		const projectEnd = Util.CreateMomentDate(project.projectEndYear, project.projectEndMonth, project.projectEndDay);

		const sortedPeriods = allRetainerPeriods.sort(this.sortByStartDate);
		const firstRetainerPeriod = sortedPeriods[0];
		const latestRetainerPeriod = sortedPeriods[sortedPeriods.length - 1];
		const periodStart = firstRetainerPeriod ? Util.CreateMomentDate(firstRetainerPeriod.node.startYear, firstRetainerPeriod.node.startMonth, firstRetainerPeriod.node.startDay) : projectStart;
		const periodEnd = latestRetainerPeriod ? Util.CreateMomentDate(latestRetainerPeriod.node.endYear, latestRetainerPeriod.node.endMonth, latestRetainerPeriod.node.endDay) : projectEnd;

		const csv = {
			type: ELEMENT_TYPE.CSV,
			callback: this.exportCSV.bind(this),
			style: BUTTON_STYLE.OUTLINE,
			color: BUTTON_COLOR.LIGHTGREY,
			text: formatMessage({id: 'common.export-csv'}),
			tooltipEnabled: true,
			tooltipProps: {
				autoPlace: true,
				grey: true,
				infoText: formatMessage({id: 'common.export-csv'}),
			},
		};
		leftContent.push(csv);

		const addNew = {
			type: ELEMENT_TYPE.BUTTON,
			id: 'NEW_RETAINER',
			text: formatMessage({id: 'retainer.new_periods'}),
			callback: this.addPeriod.bind(this),
			disabled: projectLocked || !projectStart,
			style: BUTTON_STYLE.OUTLINE,
			color: BUTTON_COLOR.PURPLE,
			dataCy: 'retainer-new-period-btn',
		};
		rightContent.push(addNew);

		const offset = this.state.topOffset ? this.state.topOffset + 60 : 150;
		const scrollSize = window.innerHeight - offset;

		const manualAllocations = project.useManualAllocations;
		const showRemainingCapacity = inHours && manualAllocations && !project.isInProjectGroup;

		// BEGIN chart stuff
		const {gradientStroke, gradientFill, gradientStrokeFixedPrice} = getGradients();

		let data;
		data = {
			labels: project.retainerPeriods.edges.map(period => truncate(period.node.name, {length: 15})),
			datasets: [],
		};
		if (!isTimeMaterial || !!project.defaultPeriodHoursAmount) {
			data.datasets.push(
				// Target Line
				{
					type: 'line',
					borderColor: gradientStrokeFixedPrice,
					pointHoverRadius: 0,
					pointHoverBorderWidth: 2,
					pointBackgroundColor: 'transparent',
					pointHoverBorderColor: gradientStrokeFixedPrice,
					pointRadius: 0,
					fill: false,
					backgroundColor: '#fff',
					borderWidth: 2,
					label: formatMessage({id: 'retainer.default_period_target'}),
					data: Array(Math.max(2, project.retainerPeriods.edges.length)).fill(inHours ? this.props.viewer.project.defaultPeriodHoursAmount : this.props.viewer.project.defaultPeriodPriceAmount),
				},
				// Retainer Target
				{
					label: formatMessage({id: 'retainer.period_target'}),
					borderColor: gradientStroke,
					backgroundColor: gradientFill,
					lineTension: 0,
					fill: true,
					borderWidth: 1,
					data: project.retainerPeriods.edges.map(period => {
						if (inHours) {
							const periodDifferenceHoursAmount = period.node.periodDifferenceHoursAmount + period.node.sharedPeriodDifferenceHoursAmount;
							return periodDifferenceHoursAmount < 0 ? period.node.periodHoursAmount - Math.abs(periodDifferenceHoursAmount) : period.node.periodHoursAmount;
						} else {
							const periodDifferencePriceAmount = period.node.periodDifferencePriceAmount + period.node.sharedPeriodDifferencePriceAmount;
							return periodDifferencePriceAmount < 0 ? period.node.periodPriceAmount - Math.abs(periodDifferencePriceAmount) : period.node.periodPriceAmount;
						}
					}),
					stack: 1,
				}
			);
		}
		if (!isTimeMaterial) {
			data.datasets.push(
				// Negative Rollover/Subtraction
				{
					label: inHours ? formatMessage({id: 'retainer.subtracted_hours'}) : formatMessage({id: 'retainer.subtracted_price'}),
					lineTension: 0,
					fill: true,
					borderWidth: 1,
					borderColor: '#e6e6e6',
					data: project.retainerPeriods.edges.map(period => {
						if (inHours) {
							const periodDifferenceHoursAmount = period.node.periodDifferenceHoursAmount + period.node.sharedPeriodDifferenceHoursAmount;
							return periodDifferenceHoursAmount < 0 ? periodDifferenceHoursAmount : 0;
						} else {
							const periodDifferencePriceAmount = period.node.periodDifferencePriceAmount + period.node.sharedPeriodDifferencePriceAmount;
							return periodDifferencePriceAmount < 0 ? periodDifferencePriceAmount : 0;
						}
					}),
					stack: 1,
				},
				// Positive Rollover
				{
					label: inHours ? formatMessage({id: 'retainer.rollover_hours'}) : formatMessage({id: 'retainer.rollover_price'}),
					lineTension: 0,
					fill: true,
					borderWidth: 1,
					borderColor: '#a1a1a1',
					data: project.retainerPeriods.edges.map(period => {
						if (inHours) {
							const periodDifferenceHoursAmount = period.node.periodDifferenceHoursAmount + period.node.sharedPeriodDifferenceHoursAmount;
							return periodDifferenceHoursAmount > 0 ? periodDifferenceHoursAmount : 0;
						} else {
							const periodDifferencePriceAmount = period.node.periodDifferencePriceAmount + period.node.sharedPeriodDifferencePriceAmount;
							return periodDifferencePriceAmount > 0 ? periodDifferencePriceAmount : 0;
						}
					}),
					stack: 1,
				}
			);
		}
		if (!isEstimatedInPoints) {
			data.datasets.push(
				// Planned value
				{
					label: inHours ? formatMessage({id: 'retainer.planned_time'}) : formatMessage({id: isFixedPrice ? 'retainer.planned_tm_price':'retainer.planned_price'}),
					backgroundColor: '#e6e6e6',
					borderColor: '#49d156',
					borderWidth: 1,
					lineTension: 0,
					fill: true,
					data: project.retainerPeriods.edges.map(period => {
						const periodPhases = Util.getMilestonesForPeriod(period.node, phases);
						return inHours ? this.getForecastForPeriod(periodPhases) : this.getEstimatedForecastPriceForPeriod(periodPhases);
					}),
					stack: 2,
				}
			);
		}
		data.datasets.push(
			// Time entries value - should maybe be separated into has Conflict and no Conflict?
			{
				label: inHours ? formatMessage({id: 'common.time_entries'}) : formatMessage({id: isFixedPrice ? 'retainer.actual_tm_revenue' : 'project_budget.actual_revenue'}),
				backgroundColor: '#b7ffbe',
				borderColor: '#49d156',
				borderWidth: 1,
				lineTension: 0,
				fill: true,
				data: project.retainerPeriods.edges.map(period => (inHours ? this.getWorkedHoursForPeriod(timeRegs, period.node) : this.getWorkedPriceForPeriod(timeRegs, period.node))),
				stack: 3,
			}
		);
		if (showRemainingCapacity) {
			data.datasets.push(
				// Remaining Capacity
				{
					label: formatMessage({id: 'project_sprints.capacity-remaining-short'}),
					backgroundColor: '#ffe2ab',
					borderColor: '#fbb124',
					borderWidth: 1,
					lineTension: 0,
					fill: true,
					data: project.retainerPeriods.edges.map(period => this.getAvailableForPeriod(period.node)),
					stack: 3,
				}
			);
		}

		const chartData = canvas => {
			if (isTimeMaterial) {
				const ctx = canvas.getContext('2d');
				// Don't keep re-making patterns. We need a ctx instance first time though, so we have to do it here
				if (!this.state.standardPattern) {
					this.setPatterns(ctx);
				}
				// Planned value
				if (this.state.standardPattern) {
					data.datasets[0].backgroundColor = this.state.standardPattern;
				}
				// No rollover in Time & Material
				return data;
			}
			const ctx = canvas.getContext('2d');
			// Don't keep re-making patterns. We need a ctx instance first time though, so we have to do it here
			if (!this.state.negativePattern || !this.state.positivePattern || !this.state.standardPattern) {
				this.setPatterns(ctx);
			}
			// Negative Rollover
			if (this.state.negativePattern) {
				data.datasets[2].backgroundColor = this.state.negativePattern;
			}
			// Positive Rollover
			if (this.state.positivePattern) {
				data.datasets[3].backgroundColor = this.state.positivePattern;
			}
			// Planned value
			if (this.state.standardPattern) {
				data.datasets[4].backgroundColor = this.state.standardPattern;
			}
			return data;
		};
		// Calculation of bar widths as a function of chart width
		const baseBarWidth = 20;
		const maxChartContainerWidth = this._chart_section ? this._chart_section.clientWidth : window.innerWidth;
		// If we can't fit groups of 2 bars, with 1 bar space (3 total) per period, make bars thinner
		const barWidth = maxChartContainerWidth / allRetainerPeriods.length >= baseBarWidth * 4 ? baseBarWidth : baseBarWidth * 0.75;
		const minChartWidth = allRetainerPeriods.length * (barWidth * 4);
		// const getTargetForData = this.getTargetForData;
		const options = {
			title: {
				display: false,
			},
			legend: {
				display: true,
				position: 'bottom',
				labels: {
					boxWidth: 20,
					fontSize: 11,
					padding: 8,
				},
			},
			tooltips: {
				mode: 'index',
				intersect: true,
				backgroundColor: '#fff',
				borderColor: '#e6e6e6',
				borderWidth: 1,
				fontFamily: 'neue-haas-grotesk-text',
				titleFontColor: '#535353',
				bodyFontColor: '#535353',
				xPadding: 12,
				yPadding: 12,
				callbacks: {
					label: function (tooltipItems, data) {
						/*if (tooltipItems.yLabel < 0) {
              return data.datasets[tooltipItems.datasetIndex].label + ': ' + withSuffix(parseFloat(getTargetForData(tooltipItems, data)), true);
            }*/
						if (tooltipItems.yLabel === 0 || data.datasets[tooltipItems.datasetIndex].label === formatMessage({id: 'retainer.default_period_target'})) {
							return '';
						}
						return data.datasets[tooltipItems.datasetIndex].label + ': ' + withSuffix(parseFloat(tooltipItems.yLabel), true);
					},
				},
			},
			responsive: true,
			maintainAspectRatio: false,
			scales: {
				xAxes: [
					{
						stacked: true,
						ticks: {
							padding: 6,
							beginAtZero: true,
							min: 0,
						},
						barThickness: barWidth,
						maxBarThickness: barWidth,
						minBarLength: 5,
						gridLines: {
							offsetGridLines: true,
							drawTicks: false,
						},
					},
					{
						id: 'non-stack-x',
						stacked: false,
						display: false,
					},
				],
				yAxes: [
					{
						stacked: true,
						ticks: {
							padding: 10,
							beginAtZero: isTimeMaterial,
							//min: 0
						},
						gridLines: {
							drawTicks: false,
						},
					},
					{
						id: 'non-stack-y',
						stacked: false,
						display: false,
					},
				],
			},
			plugins: {
				datalabels: {
					display: false,
				},
			},
		};
		// END chart stuff

		const lockedRetainerPeriods = allRetainerPeriods.filter(period => period.node.periodLocked);
		const retainerPeriods = project.retainerPeriods.edges.filter(this.filterByActiveSelection.bind(this));
		const isEmpty = project.retainerPeriods.edges.length === 0;
		let periodsWithConflict = [];
		let timeEntryTotal = 0;
		allRetainerPeriods.forEach(period => {
			const periodTimeRegs = this.getTimeRegsForPeriod(timeRegs, period.node, false);
			timeEntryTotal += periodTimeRegs.reduce((acc, timeReg) => acc + (inHours ? timeReg.node.minutesRegistered / 60 : timeReg.node.price), 0);
			if (!isTimeMaterial && period.node.periodLocked && period.node.periodLockedTime && periodTimeRegs.filter(timeReg => timeRegIsInConflict(timeReg.node, period.node)).length > 0) {
				periodsWithConflict.push(period);
			}
		});

		let totalConflicted = 0;
		if (!isTimeMaterial) {
			// Who doesn't love some nested reducing
			totalConflicted = periodsWithConflict.reduce(
				(acc, period) =>
					acc +
					this.getTimeRegsForPeriod(timeRegs, period.node)
						.filter(timeReg => timeRegIsInConflict(timeReg.node, period.node))
						.reduce((accu, tReg) => accu + (inHours ? tReg.node.minutesRegistered / 60 : tReg.node.price), 0),
				0
			);
		}

		const retainerWarningTab = (
			<RetainerPeriodWarningTab
				key={'retainer-warning-tab'}
				currency={currency}
				inHours={inHours}
				timeRegs={timeRegs}
				periodsWithConflict={periodsWithConflict}
				getTimeRegsForPeriod={this.getTimeRegsForPeriod.bind(this)}
				viewer={this.props.viewer}
				useTimeApproval={useTimeApproval}
			/>
		);
		if (periodsWithConflict.length > 0) {
			leftContent.push(retainerWarningTab);
		}

		if (projectLocked) {
			const indicator = {
				type: ELEMENT_TYPE.INDICATOR,
				status: this.props.viewer.project.status,
			};
			leftContent.push(indicator);
		}

		let totalLockedHours = lockedRetainerPeriods.reduce(
			(acc, period) =>
				acc +
				this.getTimeRegsForPeriod(timeRegs, period.node)
					.filter(timeReg => !timeRegIsInConflict(timeReg.node, period.node))
					.reduce((accu, tReg) => accu + tReg.node.minutesRegistered / 60, 0),
			0
		);
		let avgWorkedHours = lockedRetainerPeriods.length > 0 ? totalLockedHours / lockedRetainerPeriods.length : 0;

		let totalLockedPrice = lockedRetainerPeriods.reduce(
			(acc, period) =>
				acc +
				this.getTimeRegsForPeriod(timeRegs, period.node)
					.filter(timeReg => !timeRegIsInConflict(timeReg.node, period.node))
					.reduce((accu, tReg) => accu + tReg.node.price, 0),
			0
		);
		let avgWorkedPrice = lockedRetainerPeriods.length > 0 ? totalLockedPrice / lockedRetainerPeriods.length : 0;
		const getShouldRetainerStartExpanded = (period, timeRegsForPeriod) => {
			if (period.periodLocked) {
				return false;
			}
			if (timeRegsForPeriod.length === 0) {
				return false;
			}
			return true;
		};
		const projectTotal = allRetainerPeriods.reduce((acc, period) => acc + (inHours ? period.node.periodHoursAmount : period.node.periodPriceAmount), 0);

		return (
			<div className={'project-retainer-periods'} ref={div => (this.retainerContainer = div)} data-cy={'periods-page'}>
				{this.props.children}
				<TopHeaderBarWrapper sidePadding={66}>
					<TopHeaderBar title={formatMessage({id: 'retainer.periods'})} />
				</TopHeaderBarWrapper>
				{this.props.viewer.availableFeatureFlags.some(flag => flag.key === 'third_level_nav') ? (
					buildThirdLevelNavHeader(leftContent, rightContent)
				) : (
					<HeaderBar innerRef={div => (this.header_bar = div)} leftContent={leftContent} rightContent={rightContent}></HeaderBar>
				)}
				{isEmpty || !projectStart ? (
					<EmptyState pageName={EMPTY_STATE.RETAINER} callback={projectStart ? null : this.goToOverview.bind(this)}></EmptyState>
				) : (
					<Scrollbars hideTracksWhenNotNeeded={true} autoHide={false} autoHeight={true} autoHeightMin={0} autoHeightMax={scrollSize}>
						<div className={'retainer-totals-wrapper'}>
							<div className={'data-visuals'}>
								<div className={'chart-and-title'} ref={div => (this._chart_section = div)}>
									<div className={'retainer-status-header'}>Retainer Status</div>
									<Scrollbars hideTracksWhenNotNeeded={true} autoHeight={false}>
										<div className={'chart-sizer'} style={{width: minChartWidth}} data-userpilot={'retainer-totals-chart'}>
											<Bar data={chartData} options={options}></Bar>
										</div>
									</Scrollbars>
								</div>
								<div className={'retainer-dashboard-wrapper'}>
									<div className={'retainer-dashboard-header-text'}>{formatMessage({id: 'retainer.retainer_totals'})}</div>
									<div className={'retainer-dashboard-contents'} data-userpilot="retainer-dashboard">
										<div className={'retainer-type'}>
											<div className={'totals-box-column half-text-wrapper'}>
												<div className={'retainer-total-text'}>{formatMessage({id: 'retainer.type'})}</div>
											</div>
											<div className={'totals-box-column half-text-wrapper'}>
												<div className={'retainer-total-data'}>{Util.getBudgetTypeTranslation(project.budgetType, this.props.intl)}</div>
											</div>
										</div>
										{isTimeMaterial && !project.defaultPeriodHoursAmount ? null : (
											<div className={'retainer-total-period-length'}>
												<div className={'totals-box-column half-text-wrapper'}>
													<div className={'retainer-total-text'}>{formatMessage({id: 'retainer.total_project_target'})}</div>
												</div>
												<div className={'totals-box-column half-text-wrapper'}>
													<div className={'retainer-total-data'}>{withSuffix(projectTotal)}</div>
												</div>
											</div>
										)}
										<div className={'retainer-total-period-work'}>
											<div className={'totals-box-column half-text-wrapper'}>
												<div className={'retainer-total-text'} title={inHours ? formatMessage({id: 'retainer.total_hours_registered'}) : formatMessage({id: isFixedPrice? 'retainer.total_tm_price_registered':'retainer.total_price_registered'})}>
													{inHours ? formatMessage({id: 'retainer.total_hours_registered'}) : formatMessage({id: isFixedPrice ? 'retainer.total_tm_price_registered' : 'retainer.total_price_registered'})}
												</div>
											</div>
											<div className={'totals-box-column text-wrapper'}>
												<div className={'retainer-total-data'}>{withSuffix(timeEntryTotal)}</div>
											</div>
										</div>
										<div className={'retainer-total-dates'}>
											<div className={'totals-box-column wrapper'}>
												<div className={'retainer-total-text'}>{formatMessage({id: 'common.dates'})}</div>
											</div>
											<div className={'totals-box-column wrapper grow'}>
												<div className={'retainer-total-data'}>{(periodStart ? periodStart.format('DD MMM YYYY') : ' ') + ' - ' + (periodEnd ? periodEnd.format('DD MMM YYYY') : '')}</div>
											</div>
										</div>
										<div className={'retainer-total-periods-and-progress'}>
											<div className={'retainer-total-periods'}>
												<div className={'totals-box-column retainer-total-text'}>{formatMessage({id: 'retainer.periods'})}</div>
												<div className={'totals-box-column retainer-total-data'}>{project.retainerPeriods.edges.length}</div>
											</div>
										</div>
										{isTimeMaterial && !project.defaultPeriodHoursAmount ? null : (
											<div className={'retainer-total-period-length'}>
												<div className={'totals-box-column half-text-wrapper'}>
													<div className={'retainer-total-text'}>{formatMessage({id: 'retainer.default_period_target'})}</div>
												</div>
												<div className={'totals-box-column half-text-wrapper'}>
													<div className={'retainer-total-data'}>{withSuffix(inHours ? project.defaultPeriodHoursAmount : project.defaultPeriodPriceAmount)}</div>
												</div>
											</div>
										)}

										<div className={'retainer-average-period-work'}>
											<div className={'totals-box-column half-text-wrapper'}>
												<div className={'retainer-total-text'} title={inHours ? formatMessage({id: 'retainer.average_hours_per_period'}) : formatMessage({id: 'retainer.average_price_per_period'})}>
													{inHours ? formatMessage({id: 'retainer.average_hours_per_period'}) : formatMessage({id: 'retainer.average_price_per_period'})}
												</div>
											</div>
											<div className={'totals-box-column text-wrapper'}>
												<div className={'retainer-total-data'}>{withSuffix(inHours ? avgWorkedHours : avgWorkedPrice)}</div>
											</div>
										</div>
										{!isTimeMaterial ? (
											<div className={'retainer-time-entry-conflicts' + (!totalConflicted ? ' none' : '')}>
												<div className={'totals-box-column half-text-wrapper'}>
													<div className={'retainer-total-text'}>{inHours ? formatMessage({id: 'retainer.conflicted_time'}) : formatMessage({id: 'retainer.conflicted_price'})}</div>
												</div>
												<div className={'totals-box-column half-text-wrapper'}>
													<div data-cy={'dashboard-time-entry-conflict-text'} className={'retainer-total-data'}>
														{withSuffix(totalConflicted)}
													</div>
												</div>
											</div>
										) : null}
									</div>
								</div>
							</div>
						</div>
						<div className={'retainer-periods-selector'}>
							<Button
								colorTheme={this.state.selectedPeriod === 'ALL' ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.MEDIUMGREY}
								buttonStyle={BUTTON_STYLE.FILLED}
								text={formatMessage({id: 'retainer.tab.all'})}
								className={'retainer-period-selector-btn'}
								onClick={this.setSelectedPeriod.bind(this, 'ALL')}
							/>
							<Button
								colorTheme={this.state.selectedPeriod === 'PAST' ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.MEDIUMGREY}
								buttonStyle={BUTTON_STYLE.FILLED}
								text={formatMessage({id: 'retainer.tab.past'})}
								className={'retainer-period-selector-btn'}
								onClick={this.setSelectedPeriod.bind(this, 'PAST')}
							/>
							<Button
								colorTheme={this.state.selectedPeriod === 'CURRENT' ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.MEDIUMGREY}
								buttonStyle={BUTTON_STYLE.FILLED}
								text={formatMessage({id: 'retainer.tab.current'})}
								className={'retainer-period-selector-btn'}
								onClick={this.setSelectedPeriod.bind(this, 'CURRENT')}
							/>
							<Button
								colorTheme={this.state.selectedPeriod === 'FUTURE' ? BUTTON_COLOR.PURPLE : BUTTON_COLOR.MEDIUMGREY}
								buttonStyle={BUTTON_STYLE.FILLED}
								text={formatMessage({id: 'retainer.tab.future'})}
								className={'retainer-period-selector-btn'}
								onClick={this.setSelectedPeriod.bind(this, 'FUTURE')}
							/>
						</div>
						<div className={'retainer-period-column-header'}>
							<div className={'retainer-period-column-name'}>
								<div className={'period-name'}> {formatMessage({id: 'common.period'})}</div>
							</div>
							<div className={'retainer-period-column-name dates center'}>{formatMessage({id: 'common.dates'})}</div>
							{isTimeMaterial && !project.defaultPeriodHoursAmount ? null : <div className={'retainer-period-column-name right'}>{formatMessage({id: 'common.progress'})}</div>}
							{<div className={'retainer-period-column-name right'}>{formatMessage({id: 'common.period_type'})}</div>}
							{isTimeMaterial && !project.defaultPeriodHoursAmount ? null : <div className={'retainer-period-column-name right'}>{formatMessage({id: 'retainer.period_target'})}</div>}
							{!isEstimatedInPoints && (
								<>
									<div className={'retainer-period-column-name right'}>{formatMessage({id: isFixedPrice ? 'retainer.tm_period_plan' : 'retainer.period_plan'})}</div>
									<div className={'retainer-period-column-name right'}>{formatMessage({id: isFixedPrice ? 'retainer.remaining_tm_period_plan' : 'retainer.remaining_period_plan'})}</div>
								</>
							)}
							{showRemainingCapacity && inHours ? <div className={'retainer-period-column-name right'}>{formatMessage({id: 'project_sprints.capacity-remaining-short'})}</div> : null}
							<div className={'retainer-period-column-name right'}>{inHours ? formatMessage({id: 'common.time_entries'}) : formatMessage({id: isFixedPrice ? 'retainer.actual_tm_revenue' : 'project_budget.actual_revenue'})}</div>
							<div className={'retainer-period-column-name right'}>{formatMessage({id: 'common.forecast'})}</div>
						</div>
						<div className={'retainer-periods-container'}>
							{retainerPeriods.length === 0 ? (
								<div className={'retainer-period-wrapper empty'} key={'empty-wrapper'}>
									<div className={'empty-periods-text'}>{formatMessage({id: 'retainer.no_' + this.state.selectedPeriod.toLocaleLowerCase() + '_periods'})}</div>
								</div>
							) : (
								retainerPeriods.map((period, index) => {
									const userpilotIndex = index === 0 ? 'first' : index === retainerPeriods.length - 1 ? 'last' : null;

									const periodPhases = Util.getMilestonesForPeriod(period.node, phases);

									const timeRegsForPeriod = this.getTimeRegsForPeriod(timeRegs, period.node);
									const milestonesForPeriod = Util.getMilestonesForPeriod(period.node, phases);
									const planForPeriod = inHours ? this.getForecastForPeriod(periodPhases) : this.getEstimatedForecastPriceForPeriod(periodPhases);
									const remainingPlanForPeriod = inHours ? this.getRemainingForPeriod(periodPhases) : this.getRemainingPriceForPeriod(periodPhases);
									const availableForPeriod = inHours ? this.getAvailableForPeriod(period.node) : 0;
									return (
										<div className={'retainer-period-wrapper'} key={period.node.id + '-wrapper'} data-cy={'retainer-period-wrapper'}>
											<RetainerPeriod
												currency={currency}
												key={period.node.id}
												userpilotIndex={userpilotIndex}
												viewer={this.props.viewer}
												project={project}
												hasFinancialAccess={hasFinancialAccess}
												startExpanded={getShouldRetainerStartExpanded(period.node, timeRegsForPeriod)}
												timeRegs={timeRegsForPeriod}
												period={period}
												milestonesForPeriod={milestonesForPeriod}
												planForPeriod={planForPeriod}
												remainingPlanForPeriod={remainingPlanForPeriod}
												availableForPeriod={availableForPeriod}
												showTaskModal={taskId => Util.showTaskModal(taskId, this.props.history)}
												withSuffix={withSuffix}
												inHours={inHours}
												isHarvestProject={!this.isConnectedParent && this.props.viewer.project.harvestProject}
												projectLocked={projectLocked}
												showRemainingCapacity={showRemainingCapacity}
												retry={this.props.retry}
												useTimeApproval={useTimeApproval}
												isEstimatedInPoints={isEstimatedInPoints}
												isFixedPrice={isFixedPrice}
											/>
										</div>
									);
								})
							)}
						</div>
					</Scrollbars>
				)}
			</div>
		);
	}
}

const projectRetainerPeriodsQuery = graphql`
	query projectRetainerPeriods_Query($projectId: String) {
		viewer {
			actualPersonId
			component(name: "retainer_periods", projectId: $projectId)
			project(id: $projectId) {
				id
			}
			...projectRetainerPeriods_viewer @arguments(projectId: $projectId)
		}
	}
`;

export {projectRetainerPeriodsQuery};

export default injectIntl(
	withRouter(
		createFragmentContainer(projectRetainerPeriods, {
			viewer: graphql`
				fragment projectRetainerPeriods_viewer on Viewer @argumentDefinitions(projectId: {type: "String"}) {
					id
					availableFeatureFlags {
						key
					}
					company {
						id
						currency
						userSeats
						virtualSeats
						tier
						isChargebeeCustomer
						currency
						useTimeApproval
						modules {
							moduleType
						}
					}
					project(id: $projectId) {
						id
						name
						isInProjectGroup
						harvestProject {
							id
						}
						projectGroupId
						companyProjectId
						status
						projectStartYear
						projectStartMonth
						projectStartDay
						projectEndYear
						projectEndMonth
						projectEndDay
						useManualAllocations
						rateCard {
							currency
						}
						statusColumnsV2(first: 1000000) {
							edges {
								node {
									id
									name
									category
									order
									jiraStatusId
								}
							}
						}
						phases(first: 1000) {
							edges {
								node {
									id
									name
									startYear
									startMonth
									startDay
									deadlineDay
									deadlineMonth
									deadlineYear
									forecast
									estimateForecastPrice
									remaining
									remainingPrice
									phasePersons(first: 10000) {
										edges {
											node {
												id
												availableMinutes
												scheduledMinutes
												person {
													id
												}
											}
										}
									}
								}
							}
						}
						timeRegistrations(first: 10000000) @connection(key: "Project_timeRegistrations", filters: []) {
							edges {
								node {
									id
									day
									month
									year
									createdAt
									updatedAt
									minutesRegistered
									xeroInvoiceId
									lockedInPeriod
									harvestTimeId
									harvestTask {
										id
										name
									}
									invoiced
									price
									retainerConflictHandled
									person {
										id
										firstName
										lastName
										profilePictureId
										profilePictureDefaultId
									}
									task {
										id
										name
										companyTaskId
										deadlineYear
										billable
										deadlineMonth
										deadlineDay
										startDay
										startYear
										startMonth
										blocked
										bug
										highPriority
										canStart
										canBeSetToDone
										statusColumnV2 {
											id
											name
										}
									}
									project {
										id
										name
									}
								}
							}
						}
						estimationUnit
						minutesPerEstimationPoint
						projectColor
						projectStartYear
						projectStartMonth
						projectStartDay
						projectEndYear
						projectEndMonth
						projectEndDay
						budgetType
						defaultPeriodPeriodicity
						defaultPeriodLength
						defaultPeriodBudgetType
						defaultPeriodHoursAmount
						defaultPeriodPriceAmount
						defaultPeriodSettingSubtractValue
						defaultPeriodSettingRollValue
						retainerPeriods(first: 100000) @connection(key: "Project_retainerPeriods", filters: []) {
							edges {
								node {
									id
									name
									startYear
									startMonth
									startDay
									endYear
									endMonth
									endDay
									available
									periodLength
									periodPeriodicity
									periodPriceAmount
									periodHoursAmount
									periodBudgetType
									periodSettingIgnoreForBilling
									periodSettingSubtractValue
									periodSettingRollValue
									periodSettingAddExpenses
									periodDifferencePriceAmount
									periodDifferenceHoursAmount
									sharedPeriodDifferenceHoursAmount
									sharedPeriodDifferencePriceAmount
									ignoredRolloverHours
									ignoredRolloverPrice
									periodLocked
									periodLockedTime
									periodDifferenceSplit
									invoiced
								}
							}
						}
					}
				}
			`,
		})
	)
);
